import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
  }
}

export function fulfilled(state, payload) {
  const nextState = {...state}
  if (nextState.chats[payload.chatId]) {
    nextState.chats[payload.chatId].hasNewActivities = false
  }
  nextState.hasNewActivities = Object.values(nextState.chats).some(c => c.hasNewActivities)
  return nextState
}

export function rejected(state) {
  return {
    ...state,
  }
}

export async function action(payload) {
  try {
    return await Api.markChatAsRead(payload.chatId)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
